import React from 'react';
import { useInfiniteMedia } from '../hooks/use-infinite-scroll';
import { MediaList } from './media-display';

function MediaListContainer({ mediaType, searchQuery, filters, viewMode = 'grid' }) {
  const stableFilters = React.useMemo(() => ({
    selectedGenre: filters.selectedGenre || 'all',
    sortBy: filters.sortBy || 'trending',
    fromYear: filters.fromYear || '',
    toYear: filters.toYear || '',
    imdbRating: filters.imdbRating || 0,
    rottenTomatoesRating: filters.rottenTomatoesRating || 0,
    availableLT: filters.availableLT || 'false'
  }), [
    filters.selectedGenre,
    filters.sortBy,
    filters.fromYear,
    filters.toYear,
    filters.imdbRating,
    filters.rottenTomatoesRating,
    filters.availableLT
  ]);
  
  const type = mediaType === 'tv' ? 'tv' : 'movies';
  
  const {
    items,
    totalCount,
    isLoading,
    isFetchingNextPage,
    isTransitioning,
    hasNextPage,
    fetchNextPage,
    error,
    isError,
    isRateLimited,
    refetch
  } = useInfiniteMedia(type, searchQuery, stableFilters);

  return (
    <MediaList
      mediaType={mediaType}
      searchQuery={searchQuery}
      filters={stableFilters}
      viewMode={viewMode}
      items={items}
      totalCount={totalCount}
      isLoading={isLoading}
      isFetchingNextPage={isFetchingNextPage}
      isTransitioning={isTransitioning}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
      error={error}
      isError={isError}
      isRateLimited={isRateLimited}
      refetch={refetch}
    />
  );
}

export function MovieList(props) {
  return <MediaListContainer mediaType="movie" {...props} />;
}

export function TVList(props) {
  return <MediaListContainer mediaType="tv" {...props} />;
}

export default MediaListContainer;
